module.exports = __webpack_public_path__ + "static/media/profile-icon.3f5791a5.png";